import Ursula from '../../pages/ursula/Ursula'

import PrefixEnum from '../prefixes'

export default Object.freeze([{ path: PrefixEnum.URSULA, component: Ursula }])
